const BUY_BUTTON_DISABLED_MARKETS = new Set([
  'EG',
  'ZA',
  'AE',
  'CN',
  'HK',
  'IL',
  'IN',
  'JP',
  'KR',
  'LB',
  'MN',
  'MY',
  'PH',
  'SG',
  'TH',
  'TW',
  'UZ',
  'VN',
  'GE',
  'KZ',
  'RU',
  'TR',
  'BZ',
  'CR',
  'DO',
  'GT',
  'MX',
  'NI',
  'PA',
  'PR',
  'SV',
  'NZ',
  'PF',
  'AR',
  'BO',
  'CL',
  'CO',
  'EC',
  'PE',
  'PY',
  'UY',
  'VE',
  'BR',
]);

export const isPosBuyButtonEnabledForMarket = (retailer) => {
  const country = retailer?.Country?.Abbrevation;
  return !!country && !BUY_BUTTON_DISABLED_MARKETS.has(country.toUpperCase());
};
